{
  "clearThisNote": "Effacer cette note ?",
  "deviceComment": "Commentaire",
  "leaveANote": "Laisser une note",
  "newDeviceComment": "Commentaire sur le nouvel appareil",
  "thisCommentWillBeVisibleToAllOtherUsersAssociatedWithYourFarmAccount": "Ce commentaire sera visible par tous les autres utilisateurs associés à votre compte de ferme."
}
